import { render, staticRenderFns } from "./AnimationDotsLoader.vue?vue&type=template&id=035b56f5&scoped=true&"
import script from "./AnimationDotsLoader.vue?vue&type=script&lang=js&"
export * from "./AnimationDotsLoader.vue?vue&type=script&lang=js&"
import style0 from "./AnimationDotsLoader.vue?vue&type=style&index=0&id=035b56f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b56f5",
  null
  
)

export default component.exports